import { For, Show, useContext } from 'solid-js';
import { AppContext } from '../../app-context-provider/app-context-provider';
import DynamicModuleGenerator from '../../dynamic-module-generator';
import { Grid } from '../../grid-system/grid/grid';
import { Section } from '../../grid-system/section/section';
import theme from '../../style/theme';
import { ErrorCatcher } from '../../tools/error-catcher';
import {
    gridSettings,
    Sidebar,
    SidebarContainer,
    SidebarContainerLine,
    SidebarInner
} from '../../ui-components/layouts/sidebar.style';
import { Link } from '../../ui-components/link/link';
import { ProductListCardData } from '../product/product-types';
import { fetchProducts } from '../products/fetch-products';
import { ProductsCollectionProps } from './products-collection.d';
import { createGroupedProductCard } from '../products/products';

export const ProductsCollection = (props: ProductsCollectionProps) => {
    const {viewport, localize} = useContext(AppContext);

    const isMobile = () => viewport.width <= theme.breakpoints.MOBILE;

    const productsData = fetchProducts({ tag: props?.tag });
    const loaded = () => productsData();

    return (
        <ErrorCatcher componentName='Products collection'>
            <Show when={loaded()}>
                <Show when={isMobile() && props?.button?.url}>
                    <Section
                        templateShorthand={[12]}
                        widthType={'bgFull'}
                        backgroundValue={'lightBeige'}
                        backgroundType={'color'}
                        removeSpacingBlock={true}
                    >
                        <div class="px-6 py-2">
                            <Link
                                label={localize('back', 'Back')}
                                url={props?.button?.url}
                                plainStyle={true}
                                arrowColor={'gray'}
                                arrowPosition={'left'}
                                arrowDirection={'left'}
                                labelColor={'gray'}
                            />
                        </div>
                    </Section>
                </Show>
                <Section
                    templateShorthand={[12]}
                    widthType={'bgFull'}
                    backgroundValue={'white'}
                    backgroundType={'color'}
                    removeSpacingBlock={true}
                    customCss={'padding-top: 0 !important; padding-bottom: 0 !important;'}
                >
                    <Grid {...gridSettings.container}>
                        <SidebarContainer>
                            <SidebarContainerLine>
                                <Sidebar>
                                    <SidebarInner>
                                        <div class="mb-[4.5rem] max-mobile:mb-0 max-mobile:pt-4 max-mobile:px-6">
                                            <DynamicModuleGenerator skipSectionConversion={true} content={[props?.mainHeading]} />
                                            <DynamicModuleGenerator skipSectionConversion={true} content={[props?.subHeading]} />
                                        </div>

                                        <Show when={!isMobile() && props?.button?.url}>
                                            <div class="mt-48">
                                                <DynamicModuleGenerator skipSectionConversion={true} content={[props?.button]} />
                                            </div>
                                        </Show>
                                    </SidebarInner>
                                </Sidebar>
                            </SidebarContainerLine>
                        </SidebarContainer>

                        <div class="py-[6.43rem] max-mobile:pt-0">
                            <div class="mt-8 max-mobile:mt-4">
                                <Grid {...gridSettings.listing}>
                                    <For each={productsData()}>{(product: ProductListCardData) => {
                                        return createGroupedProductCard(product);
                                    }}</For>
                                </Grid>
                            </div>
                        </div>
                    </Grid>
                </Section>
            </Show>
        </ErrorCatcher>
    );
};

ProductsCollection.parseProps = (atts: any) => {
    return {
        ...atts,
        mainHeading: atts.innerBlocks[0],
        subHeading: atts.innerBlocks[1],
        button: atts.innerBlocks[2],
        tag: atts.tag,
        labels: atts.labels,
    };
};
